import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { updateTrialStatus } from '../../services/authService';

const TrialBanner = () => {
  const { user } = useAuth();
  const [daysRemaining, setDaysRemaining] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (user && user.isTrial) {
      calculateDaysRemaining();
    }
  }, [user]);

  const calculateDaysRemaining = () => {
    if (!user.trialEndDate) return;

    const today = new Date();
    const endDate = new Date(user.trialEndDate);
    const timeDiff = endDate.getTime() - today.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    
    const remaining = Math.max(0, daysDiff);
    setDaysRemaining(remaining);
    setIsVisible(true);

    // Se o período expirou, atualizar status
    if (remaining <= 0) {
      updateTrialStatus(user.uid, false);
    }
  };

  const getBannerColor = () => {
    if (daysRemaining <= 0) return 'bg-red-500 border-red-600 text-white';
    if (daysRemaining <= 1) return 'bg-red-500 border-red-600 text-white';
    if (daysRemaining <= 2) return 'bg-red-400 border-red-500 text-white';
    if (daysRemaining <= 3) return 'bg-orange-500 border-orange-600 text-white';
    return 'bg-red-400 border-red-500 text-white';
  };

  const getIcon = () => {
    if (daysRemaining <= 1) {
      return (
        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
      );
    }
    return (
      <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
      </svg>
    );
  };

  const getMessage = () => {
    if (daysRemaining <= 0) {
      return 'Seu período de teste expirou. Entre em contato para continuar usando a plataforma.';
    }
    if (daysRemaining === 1) {
      return 'Último dia do seu período de teste! Entre em contato para continuar.';
    }
    return `Você está no período de teste. Restam ${daysRemaining} dias para testar todas as funcionalidades.`;
  };

  if (!user || !user.isTrial || !isVisible) {
    return null;
  }

  return (
    <div className={`${getBannerColor()} border-l-4 p-3 mb-4 rounded-r-lg shadow-md`}>
      <div className="flex items-center">
        {getIcon()}
        <div className="flex-1">
          <p className="font-semibold text-sm">
            {getMessage()}
          </p>
        </div>
        {daysRemaining > 0 && (
          <div className="ml-3">
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-bold bg-white text-red-600">
              {daysRemaining} {daysRemaining === 1 ? 'dia' : 'dias'}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrialBanner;
